export const LOCAL_STORAGE = {
    RIDER : 'rider',
    TOKEN: 'token',
    DEVICE_ID: 'deviceId'
}